import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';
import { useRecapSidebarCollapse } from '@confluence/confluence-recap/entry-points/useRecapSidebarCollapse.ts';

export const DEFAULT_SIDEBAR_WIDTH = 320;

export const useSideNavInitialState = () => {
	const shouldCollapseForRecap = useRecapSidebarCollapse();

	if (isStableUIEnabledForTests()) {
		return {
			initialCollapsedState: 'expanded',
			initialWidth: DEFAULT_SIDEBAR_WIDTH,
			shouldForceExpand: true,
		};
	}

	const shouldForceExpand = false;

	const persistedCollapseState =
		confluenceLocalStorageInstance.getItem(
			PERSISTED_KEYS_ON_SERVER.PERSISTED_LEFT_SIDEBAR_COLLAPSED,
		) ?? 'expanded';
	let persistedWidth = parseInt(
		confluenceLocalStorageInstance.getItem(
			PERSISTED_KEYS_ON_SERVER.PERSISTED_LEFT_SIDEBAR_WIDTH, //can return null does not handle string
		) || DEFAULT_SIDEBAR_WIDTH,
		10,
	);

	if (Number.isNaN(persistedWidth)) {
		//fix for if PERSISTED_LEFT_SIDEBAR_WIDTH is somehow a string
		persistedWidth = DEFAULT_SIDEBAR_WIDTH;
	}

	let initialCollapsedState: 'collapsed' | 'expanded';
	if (shouldForceExpand) {
		initialCollapsedState = 'expanded';
	} else if (shouldCollapseForRecap) {
		initialCollapsedState = 'collapsed';
	} else {
		initialCollapsedState = persistedCollapseState;
	}

	const isWidthTooLarge = persistedWidth > window.innerWidth;
	const fittedSidebarWidth = isWidthTooLarge ? DEFAULT_SIDEBAR_WIDTH : persistedWidth;
	return {
		initialCollapsedState,
		initialWidth: fittedSidebarWidth,
		shouldForceExpand,
	};
};
